import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'shared-error-message',
  imports: [CommonModule],
  templateUrl: './error-message.component.html',
  styleUrl: './error-message.component.css',
  standalone: true
})
export class ErrorMessageComponent {
  @Input() message: string = 'Ha ocurrido un error';
  @Input() showIcon: boolean = true;
  @Input() customClass: string = '';
}